import API from "@/services/api";
import { SignUpDataAPI, SignUpResponse } from "../types/signup";
import { GetSignUpUserDataResponse } from "@/types/models/services";

enum Endpoints {
  ConfirmSignUp = '/signup/confirm',
  GetSignUpUserData = "/signup/data/:signup_data_token"
};


export const confirmSignUp = (data: SignUpDataAPI) => {

  return API.post<SignUpResponse, SignUpDataAPI>({
    endpoint: Endpoints.ConfirmSignUp,
    versions: [1],
    data
  });
}

const getSignUpUserData = async (signUpDataToken: string) => {
  try {
    const response = await API.get<GetSignUpUserDataResponse>({
      endpoint: Endpoints.GetSignUpUserData,
      params: {
        signup_data_token: signUpDataToken
      },
    });

    return response.promise.data ?? false;
  } catch (error) {
    console.error("Error getting signUp data:", error);
    return false;
  }
}

export default {
  confirmSignUp,
  getSignUpUserData
};


